
import { createAction, props } from '@ngrx/store';

export const loadCorporateData = createAction('[Data Corporate API] Load Data');
export const loadCorporateDataSuccess = createAction('[Data Corporate API] Load Data Success', props<any>());
export const loadCorporateDataFailure = createAction('[Data Corporate API] Load Data Failure', props<any>());
